import styled from 'styled-components'

const StyledCoursePreviewView = styled.div`
  .width-controller {
    gap: 20px;
    display: grid;
    padding: 30px;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
    color: ${({ theme }) => theme.color.gray[800]};
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    .width-controller {
      padding: 50px 16px;
      max-width: 955px;
      margin: 0 auto;
      gap: 62px;
      grid-template-columns: 600px minmax(0, 1fr);
    }
  }
`

export default StyledCoursePreviewView
